import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'antd'
import { ContentDetailSection, ContentValue } from 'Store/manage-content/types'
import { AppInput, UploadForm } from 'Components/form'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Editor } from '@tinymce/tinymce-react'
import { appConfig } from 'config'

type Props = {
  formData: ContentValue
  onUpdate?: (formData: ContentValue) => void
  accessToken?: string
  detail?: ContentDetailSection
  maxChar?: number
  visible: boolean
}

const ContentForm: React.FunctionComponent<Props> = props => {
  const { formData, onUpdate = () => {}, accessToken = '', detail, maxChar = 1000, visible } = props
  const [editorState, setEditorState] = React.useState(() => '')

  const editorRef = useRef(null) as any
  const [dirty, setDirty] = useState(false)
  useEffect(() => {
    setDirty(false)
  }, [editorState])

  const onUpdateData = (val: string, key: string) => {
    onUpdate({
      ...formData,
      [key]: val,
    })
  }

  useEffect(() => {
    if (detail) {
      setEditorState(detail.body)
    } else {
      setEditorState('')
    }
  }, [detail])

  const isRequired = (name: string) => {
    return false
  }

  const isError = (name: string) => {
    return false
  }

  const toolbarConfig = {
    display: [
      'INLINE_STYLE_BUTTONS',
      'BLOCK_TYPE_BUTTONS',
      'BLOCK_TYPE_DROPDOWN',
      'LINK_BUTTONS',
      'HISTORY_BUTTONS',
    ],
    INLINE_STYLE_BUTTONS: [
      { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
      { label: 'Italic', style: 'ITALIC' },
      { label: 'Underline', style: 'UNDERLINE' },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: 'Normal', style: 'unstyled' },
      { label: 'Heading Small', style: 'header-three' },
      { label: 'Heading Medium', style: 'header-two' },
      { label: 'Heading Large', style: 'header-one' },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' },
    ],
  } as any

  const countText = (html: string) => {
    const text = html.replace(/<(.|\n)*?>/g, '')
    return text.length
  }

  const onChange = () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent()
      onUpdateData(content, 'body')
      setDirty(false)
      editorRef.current.setDirty(false)
    }
  }

  return (
    <BoxWrapper>
      {/* <BoxTitle>{type}</BoxTitle> */}
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={8} xs={24}>
          <UploadForm
            token={accessToken}
            onUpdateData={onUpdateData}
            currentFile={formData.image}
            folder="content"
            listType="picture-card"
            isPrivate={true}
            acceptType="image/png,image/jpeg"
            withCropImage={true}
            aspect={1}
            name="image"
            description="ขนาดไฟล์รูปที่อัปโหลดต้องมีขนาด 40KB - 10.24 MB (.png .jpeg)"
            isRequired={isRequired('image')}
            isError={isError('image')}
            label="รูปภาพ"
            isCompress={true}
            maxFileSize={10240}
            minFileSize={40}
          />
          <AppInput
            name="alt"
            label="Image Alt Text"
            placeHolder="ระบุ Image Alt Text"
            isRequired={isRequired('alt')}
            isError={isError('alt')}
            value={formData.alt}
            onChange={onUpdateData}
          />
        </Col>
        <Col md={16} xs={24}>
          <AppInput
            name="title"
            label="Title"
            placeHolder="ระบุ Title"
            isRequired={isRequired('title')}
            isError={isError('title')}
            value={formData.title}
            onChange={onUpdateData}
          />
          {/* <RichTextEditor
            value={editorState}
            onChange={(val: EditorValue) => {
              if (countText(val.toString('html')) > maxChar) {
                setEditorState(RichTextEditor.createValueFromString(editorState.toString('html'), 'html'))
              } else {
                setEditorState(val)
              }
            }}
            toolbarClassName="edt-toolbar"
            editorClassName="edt-editor"
            placeholder="ระบุ Text Content"
            toolbarConfig={toolbarConfig}
          /> */}
          <Editor
            apiKey={appConfig?.editorKey || ''}
            init={{
              height: 300,
              //menubar: false,
              plugins: ['autolink', 'lists', 'link', 'image'],
              // toolbar:
              //   'undo redo | formatselect | ' +
              //   'bold italic backcolor | alignleft aligncenter ' +
              //   'alignright alignjustify | bullist numlist outdent indent | ' +
              //   'removeformat | help',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
            initialValue={editorState}
            onInit={(evt, editor) => (editorRef.current = editor)}
            onDirty={() => {
              console.log('onDirty')
              setDirty(true)
            }}
            value={formData.body}
            onEditorChange={newValue => {
              if (countText(newValue) <= maxChar) {
                onUpdateData(newValue, 'body')
              }
            }}
          />
          <CountTextWrapper>
            {countText(formData.body || '')}/{maxChar}
          </CountTextWrapper>
        </Col>
      </Row>
    </BoxWrapper>
    // <p>react-rte</p>
  )
}

const CountTextWrapper = styled.div`
  width: 100%;
  text-align: right;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

export default ContentForm
